import React from 'react';
var css = {
  "feedbackIcon": "rui-ESeqY",
  "success": "rui-bXiUr",
  "error": "rui-6eBk0",
  "warning": "rui-kXOAk"
};
import Icon from '../Icon/Icon';
import classNames from 'classnames';
export var ICONS = {
  success: 'ok',
  error: 'cross',
  warning: 'attentionHaired'
};
export var BORDER_DIVIDER = 2.7;
export var DIAMETER_MULTIPLIER = 2.5;
var FeedbackIcon = function FeedbackIcon(_ref) {
  var type = _ref.type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 90 : _ref$size;
  var style = {
    borderWidth: size / BORDER_DIVIDER,
    width: size * DIAMETER_MULTIPLIER,
    height: size * DIAMETER_MULTIPLIER
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.feedbackIcon, css[type]),
    style: style,
    "data-aut-id": "feedbackIcon"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: ICONS[type],
    size: size
  }));
};
export default FeedbackIcon;